module.exports = __webpack_public_path__ + "img/region.13bccc50.svg";